import React, { Component } from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import routerData from "./routerData";
import GetRouter from './getRouter.js';

class Router extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <HashRouter>
                <Switch>
                    {routerData.map((route, i) => (
                        <GetRouter key={i} {...route} />
                    ))}
                </Switch>
            </HashRouter>
        );
    }
}

export default Router;
